import { getCurrentDate, getDaysBetween } from 'utils/date';
import { pushGTMAppointmentBookedEvent, types } from 'utils/gtm';
import { getFormattedDateTime } from 'utils/momentHelpers';
import getCountryByLang from 'utils/getCountryByLang';
import { pushEdgeTagAppointmentBookedEvents } from 'utils/edgetag';

const pushAppointmentBookedTracking = (
  { stepLocationData, stepTimeData, rescheduleData, service, funnelType },
  bookingData,
) => {
  const [sdate, stime] = getFormattedDateTime(stepTimeData?.time);
  const currentDate = getCurrentDate();
  const daysBetween = getDaysBetween(currentDate, sdate);

  const eventBody = {
    location: stepLocationData?.code,
    appointmentId: bookingData.appointmentid,
    hourOfDay: stime,
    selectedDate: sdate,
    currentDate,
    service,
    funnelType,
    daysBetween: `${daysBetween}`,
    customer: bookingData?.customer || 'false',
    type: rescheduleData ? types.reschedule : types.book,
    personalDetails: {
      firstName: bookingData.firstname,
      lastName: bookingData.lastname,
      email: bookingData.email,
      phone: bookingData.phone,
      country: getCountryByLang(bookingData.locale)?.shortName,
    },
  };

  pushGTMAppointmentBookedEvent(eventBody);
  pushEdgeTagAppointmentBookedEvents(eventBody);
};

export default pushAppointmentBookedTracking;
